<!--
 * @Author: piaopiao.huang
 * @Date: 2021-09-16 11:31:05
 * @LastEditors: piaopiao.huang
 * @LastEditTime: 2022-08-08 10:34:57
 * @Description:
-->
<template>
  <div
    v-cloak
    id="app"
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
